import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilterDescending: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFilterDescending"><Path d="M14.5 20.5V18.75L16.75 13.5H18.25L20.5 18.75V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 3.5H20.5V4.08333L14.5 9.91667V10.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 17.5L6.5 20.5L9.5 17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15 18.75H20" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 3.5V20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFilterDescending;
